<template>
  <!-- création d'un custom event qui servira dans le composant pere à afficher une carte centrée sur les coordonnées de la balise -->
  <div class="livewind">
    <!-- <button @click="drawHistory">Voir l'historique</button> -->
    <div class="container" :class="{ recentupdate: recentUpdate }">
      <h2>{{ name.toUpperCase() }}</h2>
      <h3>{{ timeAgo }} mn ago</h3>
      <h3>{{ liveWind.wind_dir }}° {{ liveWind.wind_speed_avg }} km/h</h3>
      <h3>
        min: {{ liveWind.wind_speed_min }} max:
        {{ liveWind.wind_speed_max }} km/h
      </h3>
      <canvas
        @click.stop="$emit('showMap', { lat: liveWind.lat, lon: liveWind.lon })"
        ref="canvas"
        @mouseover="dessine(this.liveWind.wind_speed_max, 'red')"
        @mouseleave="dessine(this.liveWind.wind_speed_avg)"
      >
      </canvas>
    </div>
    <div id="myPlot"></div>
    <div id="mySector"></div>
  </div>
</template>
<script>
import WindRose from "../windRose";
import polarSector from "../assets/polarSector";
// import io from 'socket.io-client'
export default {
  name: "Balise",
  props: ["idBalise", "name"],
  emits: ["showMap"],
  data() {
    return {
      liveWind: {},
      // direction: 0,
      rose: null,
      recentUpdate: false,
      timeAgo: 0,
      history: [],
      showHistory: true,
    };
  },
  watch: {
    history(oldhisto, newhisto) {
      console.log("trigger history watcher");
      this.drawHistory();
    },
  },
  methods: {
    drawHistory() {
      //dessine un graphique du vent dans les deux dernières heures
      console.log("drawing history");
      console.log("this.history", this.history);
      const Xarray = this.history.map((value) => {
        return parseFloat(value.time);
      });
      console.log("Xarray", Xarray);
      const minSpeedArray = this.history.map((value) => {
        return value.wind_speed_min;
      });
      const avgSpeedArray = this.history.map((value) => {
        return value.wind_speed_avg;
      });
      const maxSpeedArray = this.history.map((value) => {
        return value.wind_speed_max;
      });
      const directionArray = this.history.map((value) => {
        return value.wind_dir;
      });

      const avg_trace = {
        x: Xarray,
        y: avgSpeedArray,
        mode: "lines",
        name: "vent moyen",
      };
      const max_trace = {
        x: Xarray,
        y: maxSpeedArray,
        mode: "lines",
        name: "vent max",
        line: {
          width: 1,
          dash: "dot",
          color: "red",
        },
      };
      const min_trace = {
        x: Xarray,
        y: minSpeedArray,
        mode: "lines",
        name: "vent mini",
        line: {
          width: 1,
          dash: "dot",
        },
      };
      const data = [avg_trace, max_trace, min_trace];
      const layout = {
        xaxis: {
          automargin: true,
          tickangle: 45,
          range: [120, 0],
          zeroline: false,
          showgrid: false,
          showticklabels: true,
          tickmode: "array",
          //   tickvals: [120, 60, 0],
          //   ticktext: ["-2h", "-1h", "0"],
        },
        yaxis: {
          //   tickvals: [10, 20, 30, 40],
          //   ticktext: [10, 20, 30, 40],
          dtick: 10,
          tickmode: "array",
          automargin: true,
          //   range: [0, 60],
          autorange: true,
          title: "km/h",
          zeroline: false,
          showgrid: false,
        },
        title:
          "Historique force vent 2 heures " + "<br>" + this.name.toUpperCase(),
      };
      Plotly.newPlot("myPlot", data, layout, { displayModeBar: false });
      const sectorChart = polarSector(Xarray, directionArray);
      Plotly.newPlot("mySector", sectorChart.data, sectorChart.layout, {
        displayModeBar: false,
      });
    },
    handleClick() {
      console.log(this.$refs.mypath);
      this.direction += angle;
      console.log(this.direction);
      this.$refs.mypath.setAttribute(
        "transform",
        `rotate(200 105 ${this.direction})`
      );
    },
    dessine(wind_force, colour = "#ffff00") {
      // this.direction = this.angle
      const rose = new WindRose(this.$refs.canvas, 200, 200);
      //attention la fleche indique d'ou vient le vent donc il faut inverser la direction
      rose.arrow(180 + this.liveWind.wind_dir, wind_force, false, colour);
    },
    async fetchBalise() {
      const res = await fetch(
        `http://api.pioupiou.fr/v1/live/${this.idBalise}`
      );
      const json = await res.json();
      return json.data;
    },
    async fetchHistory() {
      //récupère les données de vent des deux dernières heures
      const timeRef = new Date(Date.now());
      //ote 2h à l'heure actuelle
      timeRef.setHours(timeRef.getHours() - 2);
      const url = `http://api.pioupiou.fr/v1/archive/${
        this.idBalise
      }?start=${timeRef.toISOString()}&stop=now&format=json`;
      const resp = await fetch(url);
      const json = await resp.json();
      return json;
    },
    updateHistory() {
      //fetch datas from last 2 hours
      this.fetchHistory()
        .then((data) => {
          // console.log(data.data);
          // traitement de la réponse
          const formatedDatas = [];
          data.data.forEach((value, index) => {
            let _time =
              new Date(Date.now()).getTime() - new Date(value[0]).getTime();
            _time = (_time / (1000 * 60)).toFixed(0);
            const min_wind = value[3];
            const avg_wind = value[4];
            const max_wind = value[5];
            const heading = value[6];
            const dataObj = {
              time: _time,
              wind_speed_min: min_wind,
              wind_speed_avg: avg_wind,
              wind_speed_max: max_wind,
              wind_dir: heading,
            };
            formatedDatas.push(dataObj);

            this.history = formatedDatas;
            // for (let item of this.history) {
            //     console.log(item.time, item.wind_speed_avg, item.wind_dir);
            // }
          });
        })
        .catch((err) => console.log(err.message));
    },

    async updateWindBalise() {
      const json = await this.fetchBalise();
      // const lastMesure = ((Date.now() - new Date(json.measurements.date).getTime()) / (60 * 1000)).toFixed(0)
      const lastMesure = new Date(json.measurements.date).getTime();
      this.timeAgo = ((Date.now() - lastMesure) / 60000).toFixed(0);
      const liveWind = {
        wind_speed_avg: json.measurements.wind_speed_avg,
        wind_dir: json.measurements.wind_heading,
        wind_speed_max: json.measurements.wind_speed_max,
        lastMesure: lastMesure,
        wind_speed_min: json.measurements.wind_speed_min,
        lat: json.location.latitude,
        lon: json.location.longitude,
      };
      return liveWind;
    },
    updateComponent() {
      this.updateWindBalise().then((resp) => (this.liveWind = resp));
      this.updateHistory();
    },
  },
  created() {
    this.socket = io.connect("http://api.pioupiou.fr/v1/push");
    this.socket.on("connect", () => {
      console.log("socket connected");
      this.socket.emit("subscribe", this.idBalise);
    });
    this.socket.on("measurement", (data) => {
      if (this.idBalise === data.station_id) {
        console.log("Nouvelle mesure pour", this.name, data);
        //on fait passer le fond du composant en rouge pendant 2 secondes pour indiquer qu'il y a eu une mise jour
        this.recentUpdate = true;
        setTimeout(() => {
          this.recentUpdate = false;
        }, 2000);
        //mise à jour des données
        this.liveWind.wind_speed_avg = data.wind_speed_avg;
        this.liveWind.wind_speed_min = data.wind_speed_min;
        this.liveWind.wind_speed_max = data.wind_speed_max;
        this.liveWind.wind_dir = data.wind_heading;
        this.timeAgo = (
          (Date.now() - new Date(data.date).getTime()) /
          60000
        ).toFixed(0);
      }
    });
  },
  beforeDestroy() {
    if (this.socket) {
      console.log("kill socket");
      this.socket.disconnect();
    }
  },
  beforeMount() {
    console.log("updating component", this.name);
    this.updateComponent();
  },

  mounted() {
    // const interval = 1 //periode de rafraichissement en minute
    // const repeatUpdate = setInterval(this.updateComponent, interval * 60 * 1000)
    this.timeAgo = ((Date.now() - this.liveWind.lastMesure) / 60000).toFixed(0);
    setInterval(() => {
      this.timeAgo = ((Date.now() - this.liveWind.lastMesure) / 60000).toFixed(
        0
      );
    }, 60000);
    console.log(this.name, "balise mounted");
    this.socket.emit("subscribe", this.idBalise);
    console.log(this.name, "socket subscribe");
  },
  unmounted() {
    console.log(this.name, "unmounted");
    this.socket.emit("unsubscribe", this.idBalise);
    console.log(this.name, "socket unsubscribe");
  },
  beforeUpdate() {
    // this.updateComponent()
  },
  updated() {
    // console.log(this.name, "updated");
    // this.updateComponent()
    this.dessine(this.liveWind.wind_speed_avg);
  },

  computed: {},
};
</script>
<style>
.container {
  /* border: 1px solid blue;
    background: #bebfc0;
    border-radius: 10px; */
  font-size: small;
  display: inline-block;
  vertical-align: top;
}

.recentupdate {
  background-color: brown;
}

#myPlot,
#mySector {
  /* display: inline-block; */
  /* height: 300px; */
  /* border: 1px solid rgb(72, 178, 216); */
  margin: auto;
  width: 400px;
  opacity: 0.9;
}

.livewind {
  border: 1px, solid, burlywood;
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  background-image: url("../assets/mont-ventoux.jpg");
  background-repeat: no-repeat;
  background-attachment: fixed;
  color: #310412;
}
@media screen and (max-width: 1100px) {
  .livewind {
    grid-template-columns: auto;
  }
  #mySector,
  #myPlot {
    width: 450px;
  }
}
</style>
